import { Fiat, FiatWallet } from "@models";
export interface CashPlusConfigurationsApi {
	configurations: FiatWalletsConfigurations[];
	payout_frequency: string;
}

export interface FiatWalletsConfigurations {
	fiat_pid: string;
	fiat_id: string;
	asset_pid: string;
	asset_id: string;
	annual_percentage_rate: string;
	individual_annual_percentage_rate: string;
}

export interface CashPlusSubscriptionsApi {
	account_id: string;
	subscribed: boolean;
}

export interface CashPlusPortfolioApi {
	asset_pid: string;
	asset_symbol: string;
	asset_type: string;
	asset_group: string;
	asset_balance: string;
	fiat_balance: string;
	parked_asset_balance: string;
	reserved_asset_balance: string;
	usable_asset_balance: string;
	available_asset_balance: string;
	total_rewards: string;
	last_reward: string;
}

export interface CashPlusApiCombined {
	subsState: CashPlusSubscriptionsApi;
	configState: CashPlusConfigurationsApi;
	configPidState: FiatWalletsConfigurations;
	portfolioState: CashPlusPortfolioApi;
}

export interface isFundReleasedInterface {
	status: FundReleaseStatus;
}

export enum FundReleaseStatus {
	InProgress = "IN_PROGRESS",
	Completed = "COMPLETED",
	Failed = "FAILED"
}

export enum OptStatus {
	OptIn = "OPT_IN",
	OptOut = "OPT_OUT"
}

export interface ICashPlusFiatWallet {
	id: string;
	pid: string;
	logo: string;
	name: string;
	fiatWallet: FiatWallet;
	assetBalance: string;
	fiatBalance: string;
	parkedAssetBalance: string;
	availableAssetBalance: string;
	showFiatConversion?: boolean;
	defaultFiat: Fiat;
	isEligible?: boolean;
	isOptIn?: boolean;
}

export interface SellCombinedFiatWallet {
	cashPlusFiatWallets: ICashPlusFiatWallet[];
	remainingFiatWallets: FiatWallet[];
}

export interface IRolloutList {
	symbol: string;
	time: string;
}
